import React from "react";
import Chart from "react-google-charts";
import Loader from "../../../components/ui/Loader/Loader";

const BarGraph = ({
    value1,
    value2,
    title = "",
    label1 = "Asset 1",
    label2 = "Asset 2",
    unit = "",
    colors = ["#53a8e3", "#f4c430"]

}) => {
      
    const num1 = parseFloat(value1) || 0;
    const num2 = parseFloat(value2) || 0;

    const chartData = [
        ["Asset", "Value", { role: "style" }, { role: "annotation" }],
        [label1, num1, "color: #53a8e3", `${num1.toFixed(2)} ${unit}`],
        [label2, num2, "color: #f4c430", `${num2.toFixed(2)} ${unit}`]
    ];


    const chartOptions = {
        legend: { position: "none" },
        bar: { groupWidth: "35%" },

        vAxis: {
            textPosition: "none",
        },

        chartArea: {
            width: "60%",
            height: "60%",
            left: 30,
            top: 1
        },
        annotations: {
            alwaysOutside: false,
            textStyle: { fontSize: 9 }
        },

        animation: {
            startup: true,
            duration: 200
        }
    };



    return (
        <div style={{
            position: "relative",
            zIndex: 1
        }}>
            <Chart
                chartType="BarChart"
                width="100%"
                height="60px"
                data={chartData}
                options={chartOptions}
                loader={<div style={loaderStyle}><Loader /></div>}
            />

        </div>
    );
};

const loaderStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "25%",
    color: "#666"
};

export default BarGraph;
